import ApiBase from './Api'
import { IssuesGroupEntity } from 'types/IssuesGroupEntity'

const ISSUE_GROUPS_API_PATHS = {
    ISSUE_GROUPS: '/issuesgroups',
}

class IssuesGroupApi extends ApiBase {
    async findByCompanyId(companyId: string): Promise<IssuesGroupEntity[]> {
        if (!companyId) {
            return []
        }
        const fetchedIssueGroups = await this._getRequest(ISSUE_GROUPS_API_PATHS.ISSUE_GROUPS, {
            queryParameters: {
                companyId,
            },
        })

        return fetchedIssueGroups
    }
}

export default IssuesGroupApi
